function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.4,5.75h-69A4.54,4.54,0,0,0,7,10.35V41.4a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1V79.84a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V55.55A3.4,3.4,0,0,0,12,52.71a3.28,3.28,0,1,0-6.55,0A3.37,3.37,0,0,0,7,55.55V79.84a4.54,4.54,0,0,0,4.48,4.59h69a4.54,4.54,0,0,0,4.48-4.59V10.35A4.54,4.54,0,0,0,80.4,5.75Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,63.84V30.19h7.13q4.17,0,6.31,2.27a8.94,8.94,0,0,1,2.15,6.43V54.62q0,4.74-2.29,7c-1.53,1.5-3.72,2.25-6.59,2.25Zm4.82-29.11V59.3H26a3.6,3.6,0,0,0,2.88-1,4.91,4.91,0,0,0,.85-3.19V38.89a5.09,5.09,0,0,0-.8-3.08A3.44,3.44,0,0,0,26,34.73Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.69,39.88H49.87V38.79a5.17,5.17,0,0,0-.78-2.86,3.51,3.51,0,0,0-4.23-.82,3.22,3.22,0,0,0-1,.94,4.13,4.13,0,0,0-.52,1.39,9.6,9.6,0,0,0-.14,1.63c0,.67,0,1.22.07,1.66a3.2,3.2,0,0,0,.36,1.18,2.59,2.59,0,0,0,.82.9,7.87,7.87,0,0,0,1.49.75L49.63,45a9.18,9.18,0,0,1,2.6,1.44,6.23,6.23,0,0,1,1.56,1.92A8.88,8.88,0,0,1,54.5,51a26.67,26.67,0,0,1,.19,3.29,17.49,17.49,0,0,1-.43,3.94,8.3,8.3,0,0,1-1.37,3.1,6.88,6.88,0,0,1-2.6,2.08,9.23,9.23,0,0,1-3.92.75,8.56,8.56,0,0,1-3.26-.61,7.77,7.77,0,0,1-2.6-1.7,8.37,8.37,0,0,1-1.73-2.53,7.76,7.76,0,0,1-.64-3.14v-1.8H43v1.51a3.93,3.93,0,0,0,.78,2.39,3,3,0,0,0,2.62,1.06A4.28,4.28,0,0,0,48.28,59a2.63,2.63,0,0,0,1.07-1,3.8,3.8,0,0,0,.45-1.58c0-.62.07-1.3.07-2.06a21,21,0,0,0-.1-2.17,3.66,3.66,0,0,0-.38-1.37,2.62,2.62,0,0,0-.87-.85,10.74,10.74,0,0,0-1.44-.71l-3.45-1.42a7.67,7.67,0,0,1-4.19-3.38,11.74,11.74,0,0,1-1.06-5.27,12.08,12.08,0,0,1,.52-3.59,8.32,8.32,0,0,1,1.56-2.93,7.18,7.18,0,0,1,2.53-2,8.38,8.38,0,0,1,3.66-.73,8.06,8.06,0,0,1,3.29.66,8.3,8.3,0,0,1,2.57,1.75,7.29,7.29,0,0,1,2.18,5.2Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.28,63.84V30.19H72.64v4.54H63.1V44.6h8.32v4.54H63.1V59h9.54v4.82Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDseIcon);
export default __webpack_public_path__ + "static/media/dseIcon.82a1b529.svg";
export { ForwardRef as ReactComponent };